import React, { useContext, useEffect, useState } from "react";
import Button from "../../../components/Button/Button";
import Chip from "../../../components/Chip/Chip";
import Input from "../../../components/Input/Input";
import MaterialIcons from "../../../components/MaterialIcons";
import GlobalContext from "../../../context/GlobalContext";
import { tabs, validRoll } from "../../../utils";
import { blobsTexture, tick } from "../../../utils/images";
import { default as completeTeam } from "../../../utils/team";
import "./add-member-details.scss";

const AddMemberDetails = () => {
	const { axiosInstance, addNewMember } = useContext(GlobalContext);
	const [member, setMember] = useState({
		name: "",
		roll: "",
		email: "",
		image: "",
		title: "",
		status: "",
		tags: [],
		linkedin: "",
		insta: "",
		tel: "",
		mail: "",
		twitter: "",
		verified: false,
	});
	const [activeSection, setActiveSection] = useState(1);
	const [isValidInput, setIsValidInput] = useState(false);
	const [otp, setOtp] = useState(Array(6).fill(""));
	const [showOTPBox, setShowOTPBox] = useState(false);
	const [isOtpValid, setIsOtpValid] = useState(false);
	let noOfSection = 4;
	let team = [];
	completeTeam.forEach((group) => {
		team = [...team, ...group.members];
	});

	const validate = () => {
		setIsValidInput(() => false);
		for (const person of team) {
			if (person.roll === +member.roll) {
				if (person.verified) alert("User already exists");
				else alert("User already exists but not verified");
				return false;
			}
		}

		switch (activeSection) {
			case 1:
				if (
					member.name.length &&
					validRoll(member.roll) &&
					isOtpValid
				) {
					setIsValidInput(() => true);
					return true;
				}
				return false;
			case 2:
				if (member.title.length && member.image.length) {
					setIsValidInput(() => true);
					return true;
				}
				return false;
			case 3:
				if (member.linkedin.length) {
					setIsValidInput(() => true);
					return true;
				}
				return false;
			case 4:
				if (member.tags.length && member.email.length) {
					setIsValidInput(() => true);
					return true;
				}
				return false;
			default:
				setIsValidInput(() => false);
				return false;
		}
	};

	const handleChange = (e) => {
		setMember({ ...member, [e.target.name]: e.target.value });
		validate();
	};
	const handleTeams = (tab) => {
		if (member.tags.includes(tab.id))
			setMember((p) => ({
				...p,
				tags: p.tags.filter((tag) => tag !== tab.id),
			}));
		else setMember((p) => ({ ...p, tags: [...p.tags, tab.id] }));
		validate();
	};
	useEffect(() => {
		validate();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [activeSection]);
	const handlePartialSubmit = (e) => {
		e?.preventDefault();
		let check = validate();
		if (check) setActiveSection((p) => p + 1);
	};
	const handleSubmit = async (e) => {
		e.preventDefault();
		const finalData = {
			...member,
			mail: member.roll + "@iiitu.ac.in",
			tags: member.tags.join(","),
		};
		try {
			const resp = await addNewMember(finalData);
			if (resp) setActiveSection(5);
		} catch (error) {
			console.error(error);
		}
	};
	return (
		<main className="add-member-details">
			{activeSection > 1 && activeSection <= noOfSection && (
				<div className="add-member-details-left">
					<button
						className="icon"
						onClick={(e) => {
							e.preventDefault();
							if (activeSection > 1)
								setActiveSection((p) => p - 1);
						}}
						title="Go to Previous Section"
					>
						<MaterialIcons>arrow_back</MaterialIcons>
					</button>
				</div>
			)}
			{activeSection < noOfSection && isValidInput && (
				<div className="add-member-details-right">
					<button
						className="icon"
						onClick={(e) => {
							e.preventDefault();
							if (activeSection < 5)
								setActiveSection((p) => p + 1);
						}}
						title="Go to Next Section"
					>
						<MaterialIcons>arrow_forward</MaterialIcons>
					</button>
				</div>
			)}
			{activeSection === 1 && (
				<section
					style={{
						backgroundColor: "var(--green)",
						color: "var(--white)",
					}}
				>
					<div
						className="add-member-details-head"
						data-aos="fade-left"
					>
						<h1>
							<ol start="1">
								<li>Enter Your Name</li>
							</ol>
						</h1>
					</div>
					<div
						className="add-member-details-body"
						data-aos="fade-left"
					>
						<div className="add-member-details-body-top">
							<form onSubmit={handlePartialSubmit}>
								<Input
									name="name"
									placeholder="Your Full Name"
									value={member.name}
									onChange={handleChange}
									required
								/>
							</form>
						</div>
					</div>
					<div
						className="add-member-details-head"
						data-aos="fade-left"
					>
						<h1>
							<ol start="2">
								<li>Your Roll No.</li>
							</ol>
						</h1>
					</div>
					<div
						className="add-member-details-body"
						data-aos="fade-left"
					>
						<div className="add-member-details-body-top">
							<form
								onSubmit={async (e) => {
									e.preventDefault();
									if (validRoll(member.roll)) {
										try {
											await axiosInstance.post(
												"/api/otp/generate",
												{
													rollNo: member.roll,
													type: "user",
												}
											);
											setShowOTPBox(true);
										} catch (err) {
											console.error(err);
											alert(err.response.data.message);
										}
									} else alert("Fill a vaild Roll No.");
								}}
								className="add-member-details-body-top-form add-member-details-body-top-form-roll"
							>
								<Input
									value={member.roll}
									name="roll"
									type="text"
									placeholder="Roll No."
									onChange={handleChange}
									required
									style={{
										width: "10rem",
									}}
								/>
								<Input value="@iiitu.ac.in" disabled />
								<Button
									text="Verify your email"
									color="brown"
									type="submit"
									size="small"
								/>
							</form>
							{showOTPBox && (
								<form
									className="add-member-details-body-otp"
									style={{
										display: "flex",
										justifyContent: "flex-start",
									}}
									autoComplete="false"
									onSubmit={async (e) => {
										e.preventDefault();
										if (
											otp.every(
												(p) =>
													p.length === 1 &&
													+p >= 0 &&
													+p <= 9
											)
										) {
											try {
												const res =
													await axiosInstance.post(
														"/api/otp/verify",
														{
															rollNo: member.roll,
															otp: otp.join(""),
															type: "user",
														}
													);
												if (res.status === 200) {
													setActiveSection(() => 2);
													setIsOtpValid(true);
												}
											} catch (err) {
												console.error(err);
												alert(
													err?.response?.data?.message
												);
											}
										} else
											alert("Enter a valid 6 digit OTP");
									}}
								>
									<div className="add-member-details-body-otp__boxes">
										{otp.map((num, id) => (
											<Input
												name={"otp" + id}
												value={otp[id]}
												min={0}
												max={9}
												key={id}
												autoComplete="false"
												placeholder="0"
												onKeyUp={(e) => {
													if (
														e.target.value
															.length === 1
													) {
														if (
															e.target.value >=
																0 &&
															e.target.value <= 9
														) {
															if (
																e.target
																	.name ===
																"otp5"
															) {
																e.target.blur();
															} else {
																document
																	.getElementsByName(
																		"otp" +
																			(+e
																				.target
																				.name[
																				e
																					.target
																					.name
																					.length -
																					1
																			] +
																				1)
																	)[0]
																	.focus();
															}
														} else {
															e.target.value = "";
														}
													}
												}}
												onChange={(e) => {
													setOtp((p) => {
														let toSet = [...p];
														let v = e.target.value;
														if (
															v.length === 0 ||
															(v.length === 1 &&
																+v[0] >= 0 &&
																+v[0] <= 9)
														)
															toSet[id] =
																e.target.value;
														return toSet;
													});
												}}
											/>
										))}
									</div>
									<Button
										type="submit"
										text="Verify OTP"
										size="small"
									/>
								</form>
							)}
						</div>
					</div>
				</section>
			)}
			{activeSection === 2 && (
				<section
					style={{
						backgroundColor: "var(--blue)",
						color: "var(--white)",
					}}
				>
					<div
						className="add-member-details-head"
						data-aos="fade-left"
					>
						<h1>
							<ol start="3">
								<li>Designation</li>
							</ol>
						</h1>
					</div>
					<div
						className="add-member-details-body"
						data-aos="fade-left"
					>
						<div className="add-member-details-body-top">
							<form onSubmit={handlePartialSubmit}>
								<Input
									value={member.title}
									name="title"
									type="text"
									placeholder="Designation (E.g:- Web Developer, Graphic Designer, CP, etc)"
									onChange={handleChange}
									required
								/>
							</form>
						</div>
					</div>
					<div
						className="add-member-details-head"
						data-aos="fade-left"
					>
						<h1>
							<ol start="4">
								<li>Describe Yourself</li>
							</ol>
						</h1>
					</div>
					<div
						className="add-member-details-body"
						data-aos="fade-left"
					>
						<div className="add-member-details-body-top">
							<form onSubmit={handlePartialSubmit}>
								<Input
									value={member.status}
									name="status"
									type="text"
									placeholder="A one liner to describe yourself. (E.g:- I am an avid learner, always on the hunt for new experiences)"
									onChange={handleChange}
								/>
							</form>
						</div>
					</div>
					<div
						className="add-member-details-head"
						data-aos="fade-left"
					>
						<h1>
							<ol start="5">
								<li>Enter Your profile image url</li>
							</ol>
						</h1>
					</div>
					<div
						className="add-member-details-body"
						data-aos="fade-left"
					>
						<div className="add-member-details-body-top">
							<form onSubmit={handlePartialSubmit}>
								<Input
									value={member.image}
									name="image"
									type="url"
									placeholder="Profile Photo url (preferably focused on face)"
									onChange={handleChange}
								/>
							</form>
						</div>
					</div>
				</section>
			)}
			{activeSection === 3 && (
				<section
					style={{
						backgroundColor: "var(--pink)",
						color: "var(--white)",
					}}
				>
					<div
						className="add-member-details-head"
						data-aos="fade-left"
					>
						<h1>
							<ol start="6">
								<li>Instagram Username</li>
							</ol>
						</h1>
					</div>
					<div
						className="add-member-details-body"
						data-aos="fade-left"
					>
						<div className="add-member-details-body-top">
							<form onSubmit={handlePartialSubmit}>
								<Input
									value={member.insta}
									name="insta"
									type="text"
									placeholder="Instagram username"
									onChange={handleChange}
								/>
							</form>
						</div>
					</div>
					<div
						className="add-member-details-head"
						data-aos="fade-left"
					>
						<h1>
							<ol start="7">
								<li>LinkedIn Username</li>
							</ol>
						</h1>
					</div>
					<div
						className="add-member-details-body"
						data-aos="fade-left"
					>
						<div className="add-member-details-body-top">
							<form onSubmit={handlePartialSubmit}>
								<Input
									value={member.linkedin}
									name="linkedin"
									type="text"
									placeholder="LinkedIn username"
									onChange={handleChange}
									required
								/>
							</form>
						</div>
					</div>
					<div
						className="add-member-details-head"
						data-aos="fade-left"
					>
						<h1>
							<ol start="8">
								<li>Twitter Username</li>
							</ol>
						</h1>
					</div>
					<div
						className="add-member-details-body"
						data-aos="fade-left"
					>
						<div className="add-member-details-body-top">
							<form onSubmit={handlePartialSubmit}>
								<Input
									value={member.twitter}
									name="twitter"
									type="text"
									placeholder="Twitter username"
									onChange={handleChange}
								/>
							</form>
						</div>
					</div>
				</section>
			)}
			{activeSection === 4 && (
				<section
					style={{
						backgroundColor: "var(--brown)",
						color: "var(--white)",
					}}
				>
					<div
						className="add-member-details-head"
						data-aos="fade-left"
					>
						<h1>
							<ol start="9">
								<li>Your WhatsApp No.</li>
							</ol>
						</h1>
					</div>
					<div
						className="add-member-details-body"
						data-aos="fade-left"
					>
						<div className="add-member-details-body-top">
							<form onSubmit={handlePartialSubmit}>
								<Input
									value={member.tel}
									name="tel"
									type="tel"
									placeholder="Phone No."
									onChange={handleChange}
								/>
							</form>
						</div>
					</div>
					<div
						className="add-member-details-head"
						data-aos="fade-left"
					>
						<h1>
							<ol start="10">
								<li>Your Personal Email</li>
							</ol>
						</h1>
					</div>
					<div
						className="add-member-details-body"
						data-aos="fade-left"
					>
						<div className="add-member-details-body-top">
							<form onSubmit={handlePartialSubmit}>
								<Input
									value={member.email}
									name="email"
									type="email"
									placeholder="Personal Email"
									onChange={handleChange}
									required
								/>
							</form>
						</div>
					</div>
					<div
						className="add-member-details-head"
						data-aos="fade-left"
					>
						<h1>
							<ol start="11">
								<li>Choose Your Teams</li>
							</ol>
						</h1>
					</div>
					<div
						className="add-member-details-body"
						data-aos="fade-left"
					>
						<div className="add-member-details-body-top">
							{tabs.map(
								(tab) =>
									tab.id !== "" && (
										<Chip
											onClick={(e) => {
												e.preventDefault();
												handleTeams(tab);
												let check = validate();
												if (check)
													setIsValidInput(() => true);
											}}
											icon={tab.icon}
											text={tab.title}
											style={{
												backgroundColor: `var(--${
													tab.color
												}-${
													member.tags.includes(tab.id)
														? 700
														: 100
												})`,
												color: member.tags.includes(
													tab.id
												)
													? "var(--white)"
													: `var(--${tab.color}-700)`,
												border: `2px solid var(--${
													tab.color - 700
												})`,
											}}
										/>
									)
							)}
						</div>
					</div>
					{isValidInput && (
						<div className="add-member-details-right">
							<Button
								type="submit"
								color="green"
								icon="save"
								size="small"
								text="Submit Your Details"
								onClick={handleSubmit}
							/>
						</div>
					)}
				</section>
			)}
			{activeSection === 5 && (
				<section
					className="add-member-details-6 apply-success"
					style={{
						backgroundImage: `url(${blobsTexture})`,
					}}
				>
					<div
						className="add-member-details-success-card"
						data-aos="zoom-in"
					>
						<div className="add-member-details-success-card-image">
							<img src={tick} alt="Successful" />
						</div>
						<h1>Your Details have been submitted successfully</h1>
						<p>
							You will be added when the authorities verify your
							status.
						</p>
						<div
							className="add-member-details-success-buttons"
							style={{
								margin: "1rem 0",
							}}
						>
							<Button
								text="Explore Our Events"
								link="/events"
								color="green"
								icon="north_east"
								size="small"
								variant="outline"
							/>
							<Button
								text="Contact Us"
								link="/contact"
								color="green"
								icon="call"
								size="small"
							/>
						</div>
					</div>
				</section>
			)}
		</main>
	);
};

export default AddMemberDetails;
